module.exports = {"pagination":{"ListItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/mediastore-data-2017-09-01.paginators.json
// module id = 544
// module chunks = 0